import { lazy, Suspense } from 'react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RootContext } from '../../RootProvider';
import LoadingView from '../Interstitial/LoadingView';
const IntegrationsController = lazy(() => import('./IntegrationsController'));

const IntegrationsProvider = () => {
  const { integrations } = React.useContext(RootContext);
  return (
    <Suspense fallback={<LoadingView />}>
      <IntegrationsController viewModel={integrations} />
    </Suspense>
  );
};

export default observer(IntegrationsProvider);
